import { logEvent, type LogEntry } from '../services/api/logging';

class Logger {
  private context: string;

  constructor(context: string) {
    this.context = context;
  }

  private async log(level: LogEntry['level'], message: string, metadata?: Record<string, any>) {
    try {
      const entry: LogEntry = {
        level,
        message,
        metadata: {
          ...metadata,
          context: this.context,
          timestamp: new Date().toISOString()
        }
      };

      await logEvent(entry);
    } catch (error) {
      console.error('Logging failed:', error);
    }
  }

  info(message: string, metadata?: Record<string, any>) {
    console.info(`[${this.context}] ${message}`, metadata);
    return this.log('info', message, metadata);
  }

  warn(message: string, metadata?: Record<string, any>) {
    console.warn(`[${this.context}] ${message}`, metadata);
    return this.log('warn', message, metadata);
  }

  error(message: string, error?: any) {
    const metadata = {
      error: error instanceof Error ? {
        message: error.message,
        stack: error.stack
      } : error
    };
    console.error(`[${this.context}] ${message}`, error);
    return this.log('error', message, metadata);
  }
}

export const createLogger = (context: string) => new Logger(context);